<template>
    <div>
        <div class="mb-3 d-flex">
            <button class="btn btn-info mr-1" data-toggle="modal" data-target="#new_sale"><i class="fas fa-tag"></i>&nbsp; Create Sale</button>
            <button class="btn btn-danger mr-auto" :class="{'disabled': (sale_array < 1)}" @click="delete_sale"><i class="far fa-trash-alt"></i>&nbsp; Delete</button>
            <button class="btn btn-info mr-1" @click="query_strings.search = 'default', get_query()">View Default Sales</button>
            <div class="form-group mb-0 mr-1">
                <select class="form-control" v-model="query_strings.published" @change="get_query">
                    <option :value="null">All Sales</option> 
                    <option value="1">Published Sales</option>
                    <option value="0">Unpublished Sales</option>
                </select>
            </div>
            <div class="form-group mb-0 mr-1">
                <select class="form-control" v-model="query_strings.website_id" @change="get_query">
                    <option :value="null">All Websites</option> 
                    <option v-for="website in websites" :value="website.id">{{ website.name }}</option>
                </select>
            </div>
            <div class="form-group mb-0 mr-1 position-relative">
                <datetime v-model="query_date" placeholder="Sale Month" input-class="form-control" input-id="startDate" type="date" format="MMMM y" @close="convert_query_date" :flow="['month', 'year']"></datetime>
                <i class="fas fa-times-circle position-absolute clear-input" v-if="query_date" @click="clear_date"></i>
            </div>
            <div>                             
                <div class="input-group position-relative">
                    <input type="text" v-model="query_strings.search" @change="get_query" class="form-control" placeholder="Search Sales"/>
                    <div class="input-group-append">
                        <div class="input-group-text"><i class="fas fa-search"></i></div>
                    </div>
                    <i class="fas fa-times-circle position-absolute clear-input" v-if="query_strings.search" @click="query_strings.search = '', get_query()"></i>
                </div>
            </div>
        </div>

        <table class="table table-striped" v-if="sales.length > 0">
            <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col">Name</th>
                    <th scope="col">Website(s)</th>
                    <th scope="col">Starts</th>
                    <th scope="col">Ends</th>
                    <th scope="col">Status</th>
                    <th scope="col">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="sale in sales">
                    <td class="align-middle" scope="row">
                        <label class="custom-control custom-checkbox mb-1">
                            <input type="checkbox" class="custom-control-input" :value="sale.id" v-model="sale_array">
                            <span class="custom-control-label"></span>
                        </label>
                    </td>
                    <th class="align-middle">{{ sale.name }}</th>
                    <td class="align-middle">
                        <template v-for="(website, index) in sale.websites">
                            {{ website.name }} <br v-if="sale.websites.length > 1 && index != sale.websites.length">
                        </template>
                    </td>
                    <td class="align-middle">
                        <template v-if="sale.starts_at != null">
                            {{ readable_date(sale.starts_at) }}
                        </template>
                        <template v-else>
                            Default Sale
                        </template>
                    </td>
                    <td class="align-middle">
                        <template v-if="sale.ends_at != null">
                            {{ readable_date(sale.ends_at) }}
                        </template>
                        <template v-else>
                            Default Sale
                        </template>
                    </td>
                    <td class="text-muted align-middle font-weight-bold" v-if="sale.date_passed">Sale Date Passed</td>
                    <td class="text-success align-middle font-weight-bold" v-else-if="sale.running && sale.published_at">Sale Running</td>
                    <td class="text-info align-middle font-weight-bold" v-else-if="sale.published_at">Published</td>
                    <td class="text-danger align-middle font-weight-bold" v-else>Not published</td>
                    <td>
                        <a :href="'/sales/' + sale.id + '/edit'" class="btn btn-primary btn-sm mr-1"><i class="far fa-edit"></i>&nbsp; Edit</a>
                        <button type="button" class="btn btn-success btn-sm mr-1" @click="clear_sale_cache(sale.id)"><i class="fas fa-database"></i>&nbsp; Clear Cache</button> 
                        <button type="button" class="btn btn-info btn-sm mr-1" @click="duplicate_sale(sale.id)"><i class="far fa-copy"></i>&nbsp; Duplicate</button> 
                        <button type="button" class="btn btn-warning btn-sm mr-1" @click="publish_sale(sale.id)" v-if="sale.published_at && !sale.date_passed"><i class="fas fa-trash-restore-alt"></i>&nbsp; Unpublish</button>
                        <button type="button" class="btn btn-success btn-sm mr-1" @click="publish_sale(sale.id)" v-else-if="!sale.date_passed"><i class="fas fa-upload"></i>&nbsp; Publish</button> 
                        <button type="button" class="btn btn-danger btn-sm" @click="delete_sale('single', sale.id)"><i class="far fa-trash-alt"></i>&nbsp; Delete</button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="text-center mt-5" v-else-if="!loading">
            No results founds matching your query. <a href="#" @click.prevent="query_strings.page = 1, query_strings.published = null, query_strings.search = '', query_strings.website_id = null, query_strings.from = null, query_strings.to = null, get_query()">Reset</a>
        </div>

        <nav>
            <ul class="pagination flex-wrap">
                <li class="page-item" v-for="page in page_info.last_page" v-if="page_info.last_page != 1" :class="{'active': (page == query_strings.page)}">
                    <a class="page-link" v-if="page == query_strings.page">{{page}}</a>
                    <a class="page-link" @click.prevent="query_strings.page = page, get_query()" href="#" v-else>{{page}}</a>
                </li>
            </ul>
        </nav>

        <div class="modal fade" id="new_sale" tabindex="-1" role="dialog" aria-labelledby="new sale modal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">New Sale</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="sale">Sale Name*</label>
                            <input type="text" class="form-control" id="sale" placeholder="Sale Name" v-model="new_sale.name">
                        </div>
                        <div class="form-group">
                            <label>Starts at*</label>
                            <datetime placeholder="Starts date" v-model="new_sale.starts_at" input-class="form-control" input-id="startDate" type="datetime" format="dd/MM/y HH:mm:ss"></datetime>
                        </div>
                        <div class="form-group">
                            <label>Ends at*</label>
                            <datetime placeholder="Ends date" v-model="new_sale.ends_at" input-class="form-control" input-id="endDate" type="datetime" format="dd/MM/y HH:mm:ss"></datetime>
                        </div>
                        <div class="form-group">
                            <label>Website*</label>
                            <select class="form-control" v-model="new_sale.website_id">
                                <option :value="null" disabled>Choose website</option> 
                                <option v-for="website in websites" :value="website.id">{{ website.name }}</option>                 
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" :class="{'disabled': (new_sale.name.length < 1) || !new_sale.starts_at || !new_sale.ends_at || !new_sale.website_id}" @click="start_sale">
                            Create Sale
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

       <loader :loading="loading"></loader>

    </div>
</template>

<script>

import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import loader from './loader.vue';

export default {
    components: {
        datetime: Datetime,
        loader
    },

    data() {
        return {
            sales: [],
            page_info: [],
            websites: [],

            query_date: null,
            query_strings: {
                page: 1,
                published: null,
                search: '',
                website_id: null,
                from: null,
                to: null,
            },

            new_sale: {
                name: '',
                starts_at: null,
                ends_at: null, 
                website_id: null,
            },

            sale_array: [],
            loading: true,
        };
    },

    props: {
    },

    mounted(){
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('page')){
            this.query_strings.page = urlParams.get('page');
        }
        if(urlParams.get('published')){
            this.query_strings.published = urlParams.get('published');
        }
        if(urlParams.get('search')){
            this.query_strings.search = urlParams.get('search');
        }
        if(urlParams.get('website_id')){
            this.query_strings.website_id = urlParams.get('website_id');
        }
        if(urlParams.get('from')){
            this.query_strings.from = urlParams.get('from');
            this.query_date = moment(this.query_strings.from).format('YYYY-MM-DD');
        }
        if(urlParams.get('to')){
            this.query_strings.to = urlParams.get('to');
        }
        this.new_sale.starts_at = this.datepicker_dates(moment().startOf('day'));
        this.new_sale.ends_at = this.datepicker_dates(moment().endOf('day'));
        this.get_sales();
        this.get_websites();
    },

    methods: {
        readable_date: function (date) {
            return moment(date).format('DD/MM/YYYY HH:mm:ss');
        },
        db_date: function (date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        get_sales: function(){
            this.loading = true;
            axios.get('/sales/list',{
                params: {
                    page: this.query_strings.page,
                    published: this.query_strings.published,
                    search: this.query_strings.search,
                    website_id: this.query_strings.website_id,
                    from: this.query_strings.from,
                    to: this.query_strings.to,
                }
            })
            .then(function (response) {
                console.log(response);
                this.page_info = response.data.sales;
                this.sales = response.data.sales.data;
                this.loading = false;
                this.format_dates();
                this.new_sale.name = '';
                this.new_sale.starts_at = this.datepicker_dates(moment().startOf('day'));
                this.new_sale.ends_at = this.datepicker_dates(moment().endOf('day')); 
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
                this.loading = false;
            })
        },

        get_websites: function(){
            axios.get('/websites/list')
            .then(function (response) {
                console.log(response);
                this.websites = response.data.websites;
                this.loading = false;
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
                this.loading = false;
            })
        },

        start_sale: function(){ 
            this.loading = true;   
            axios.post('/sales', {
                name: this.new_sale.name,
                starts_at: this.db_date(this.new_sale.starts_at),
                ends_at: this.db_date(this.new_sale.ends_at),
                website_id: [this.new_sale.website_id],
                headers: {
                    'content-type': 'multipart/form-data',
                },
            })
            .then(function (response) {
                this.get_sales();
            }.bind(this))
            .catch(function (error) {
                alert(error);
                this.get_sales();
            }.bind(this))
        },

        delete_sale: function(single, id){
            this.loading = true;
            if(single){
                this.sale_array = [id];
            }
            axios.delete('/sales', {
                data: {
                    id: this.sale_array,
                }
            })
            .then(function (response) {
                this.get_sales();
                this.sale_array = [];
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error.response.data.errors.id[0]); 
                this.get_sales();
            }.bind(this))
        },

        clear_sale_cache: function(id) {
            this.loading = true;
            axios.get('/sales/' + id + '/clear-cache')
            .then(function (response) {
                this.get_sales();
                this.sale_array = [];
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
                this.get_sales();
            }.bind(this))
        },

        duplicate_sale: function(id){
            this.loading = true;
            axios.post('/sales/' + id + '/duplicate')
            .then(function (response) {
                this.get_sales();
                this.sale_array = [];
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
                this.get_sales();
            }.bind(this))
        },

        publish_sale: function(id){
            this.loading = true;
            axios.patch('/sales/' + id + '/publish')
            .then(function (response) {
                this.get_sales();
                this.sale_array = [];
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
                this.get_sales();
            }.bind(this))
        },

        convert_query_date: function(){
            if(this.query_date){
                this.query_strings.from = moment(this.query_date).startOf('month').format("YYYY-MM-DD");
                this.query_strings.to = moment(this.query_date).endOf('month').format("YYYY-MM-DD");
                this.get_query();
            }
        },

        clear_date: function(){
            this.query_date = null;
            this.query_strings.from = null;
            this.query_strings.to = null;
            this.get_query();
        },

        get_query: function(){

            let queryString = '';
            if(this.query_strings.page > 1){
                queryString += 'page=' + this.query_strings.page + '&';
            }
            if(this.query_strings.published != null){
                queryString += 'published=' + this.query_strings.published + '&';
            }
            if(this.query_strings.search.length > 0){
                queryString += 'search=' + this.query_strings.search + '&';
            }
            if(this.query_strings.website_id > 0){
                queryString += 'website_id=' + this.query_strings.website_id + '&';
            }
            if(this.query_strings.from != null){
                queryString += 'from=' + this.query_strings.from + '&';
            }
            if(this.query_strings.to != null){
                queryString += 'to=' + this.query_strings.to + '&';
            }
            if(queryString.length > 0 ){
                queryString = '?' + queryString;
                queryString = queryString.substring(0, queryString.length - 1);

            }
            history.pushState({page: 0}, "", window.location.pathname + queryString);

            this.get_sales();
        },
        datepicker_dates: function(date){
            return moment(date).format('YYYY-MM-DDTHH:mm:ss');
        },
        format_dates: function(){
            for(let sale in this.sales){
                if(moment() > moment(this.sales[sale].ends_at)){
                    Vue.set(this.sales[sale], 'date_passed', true);
                }
                if(moment() > moment(this.sales[sale].starts_at) && moment() < moment(this.sales[sale].ends_at)){
                    Vue.set(this.sales[sale], 'running', true);
                }
            }
        },

    },
};
</script>